import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function OldSolutionsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-0" style={{
    backgroundColor: '#0a0a0f'
  }} data-id="element-151">
      <div className="max-w-6xl mx-auto px-5 sm:px-8" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-153">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{
          color: '#f97316'
        }} data-id="element-154">
            Why Everything You've Tried Has Failed
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-155">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-156">
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-157">
              <span className="line-through decoration-2" style={{
              textDecorationColor: '#f97316'
            }} data-id="element-158">
                Time Blocking
              </span>
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-159">
              People just book over it. Your "focus time" is a suggestion, not a
              boundary.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.25,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-160">
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-161">
              <span className="line-through decoration-2" style={{
              textDecorationColor: '#f97316'
            }} data-id="element-162">
                Declining Invites
              </span>
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-163">
              The FOMO and the politics pull you back in. You decline Monday,
              accept by Wednesday.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.4,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-164">
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-165">
              <span className="line-through decoration-2" style={{
              textDecorationColor: '#f97316'
            }} data-id="element-166">
                Saying "I'm Busy"
              </span>
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-167">
              Everyone's busy. It's not a reason — it's a cliché that gets
              ignored.
            </p>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.6,
        ease: 'easeOut'
      }} className="text-center text-lg sm:text-xl font-semibold text-white mt-14 max-w-2xl mx-auto" data-id="element-168">
          The problem isn't your calendar — it's your{' '}
          <span style={{
          color: '#f97316'
        }} data-id="element-169">
            Scripts
          </span>
          . You don't know what to say.
        </motion.p>
      </div>
    </section>;
}